import { useEffect, useState } from "react";
import "./PasswordField.css";

// ONE password field for every surface that has one (founder, 30 Sep): owner sign-in, staff sign-in at
// /console, invite accept and reset password. A text button INSIDE the field on the right, reading
// Show, switching to Hide. It is `type="button"`, so it can never submit the form it sits in, and it
// carries an aria-label because "Show" alone does not say show WHAT.
//
// The field goes back to hidden after a submit — the parent bumps `hideOn` — and when the page is
// left, which unmounting does for free. Display only: it changes nothing about what is sent, and on
// /console it touches neither the second factor nor break-glass.
export function PasswordField({ id, value, onChange, hideOn = 0, className = "", testid, ...rest }) {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(false); }, [hideOn]);

  return (
    <div className="pw-field">
      <input id={id} className={className} type={show ? "text" : "password"} value={value}
             onChange={onChange} data-testid={testid} {...rest} />
      <button type="button" className="pw-toggle" aria-pressed={show}
              aria-label={show ? "Hide password" : "Show password"}
              data-testid={testid ? `${testid}-toggle` : "password-toggle"}
              onClick={() => setShow((s) => !s)}>
        {show ? "Hide" : "Show"}
      </button>
    </div>
  );
}
